<template>
  <busy-overlay :visible="true" />
</template>

<script>
/*
there are two ways to register the aws-mp token with user account
1. user doesn't have kyra account: 
- he is at kyra/signin and creates an account and follow (2.)
- or he finds kyra on aws-mp, and click subscribe btn and follow (r)
2. user has kyra account, so he sign in, and click the aws-do-sub, he redirects to aws-mp page, 
then clicks subscribe btn and follow (r)

r) on aws-mp calling /api/onboard we check a few conditions: a) if the token doesn't exists, 
or exists with no u_sub, we use use it, b) otherwise the token is already used. 
if (a) is true, user will be redirected to kyra/signin page with s_id=_id. now the user is either
a) signed in, call the /api/onboard with _id to register the token
b) not signed in, call the /api/onboard with userSub and email to register the token
*/

import { Auth } from "aws-amplify";
import { navigateTo } from "../router";
import BusyOverlay from "../components/commons/BusyOverlay.vue";

export default {
  components: {
    BusyOverlay,
  },
  mounted() {
    const s_id = this.$route.query.awsmp_sid;
    if (s_id)
      Auth.currentAuthenticatedUser()
        .then(async () => {
          await this.$store.dispatch("subscription/onboard", { s_id });
          await this.$store.dispatch("subscription/load");
          navigateTo({ path: "/", replace: true });
        })
        .catch(() => navigateTo({ path: `/signin?awsmp_sid=${s_id}`, replace: true }));
    else navigateTo({ path: "/" });
  },
};
</script>
